// 定制路由的判断，目前是根据id，测试环境为id为49的项目是定制导航
// 根据VUE_APP_PASSPORT_URL环境变量区分是否为正式环境、测试环境
export const customlist = (window.PASSPORT_URL && window.PASSPORT_URL === 'https://passport.linkdoc.com') ? [5] : [5];
// export const isCustom = key => location.host.indexOf('henanbc') > -1;
export const isCustom = key => customlist.includes(key);

